import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";

const SkillsAndLearningLayout = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};

export default SkillsAndLearningLayout;
